
import React from 'react';
import { useState } from 'react';
import DeleteSuccessPopup from './DeleteSuccessPopup';
const DeletePopup = ({ isOpen, onClose, onConfirm }) => {
   
 
  if (!isOpen) {
    return null;
  }

  return (
    
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={onClose} 
    >
   
      <div
        className="w-full max-w-md p-6 mx-4 bg-white rounded-lg shadow-xl"
        onClick={(e) => e.stopPropagation()} 
      >
        <div className="flex flex-col items-center text-center">
          
          <div className="flex items-center justify-center w-16 h-16 mb-4 text-5xl font-bold text-white bg-red-500 rounded-full">
            ?
          </div>

        
          <h2 className="mb-6 text-lg text-gray-700">
            Do you want to delete these all Buyer ?
          </h2>

       
          <div className="flex justify-center gap-4">
            <button
              onClick={onClose}
              className="px-8 py-2 font-semibold text-red-500 transition-colors bg-white border border-red-500 rounded-md hover:bg-gray-100"
            >
              Cancel
            </button>
            <button
          onClick={onClose}
              className="px-8 py-2 font-semibold text-white transition-colors bg-red-600 border border-red-600 rounded-md hover:bg-red-700"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
     
    </div>
  );
};
export default DeletePopup;